export default __webpack_public_path__ + "static/lufthansa-city-center_1_1_de-0152116d8b3a8d7c95d98cfd90233da8.png";